<template>
	<div>
		<div class="backdrop">
			<RouterView />
		</div>
		<div>
			<MFAValidation
				:configName="this.$store.state.Auth.mfaConfigName"
				:nextRoute="this.$store.state.Auth.mfaLoginEndpoint"
				:token="this.$store.state.Auth.mfaToken"
				@close="() => (submittingForm = false)"
			></MFAValidation>
		</div>
	</div>
</template>

<script>
	import MFAValidation from './MFAValidationModal'

	export default {
		components: {
			MFAValidation,
		},
		name: 'AuthContainer',
	}
</script>

<style lang="scss" scoped>
	.backdrop {
		height: 100vh;
		@supports (height: 100dvh) {
			height: 100dvh;
		}
		min-width: 100vw;
		overflow: scroll;
		background: var(--stan-bg-color);
	}
</style>
